import { type Grade, type LinkInternal, type Price } from '../../api-models'
import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

/**
 * Returns a description of the product pickers to display on the product page
 * @see {@link https://devportal.backmarket.io/catalog/default/api/product-page-api/definition#tag/pickers/operation/getPickers}
 */
export const getPickers = createHttpEndpoint<GetPickersResponse>({
  method: 'GET',
  operationId: 'getPickers',
  path: '/bm/product/:productId/pickers',
})

export type GetPickersResponse = HttpResponsePayload<{
  pickers: Array<{
    id: string
    trackingId?: string
    label: string
    items: Array<{
      trackingValue?: string
      label: string
      link?: LinkInternal
      selected: boolean
      available: boolean
      icon?: 'IconEyes' | 'IconSparkles'
      price?: Price
      color?: string
      goodDeal?: boolean
      grade?: Grade
      specialOfferType?: {
        type: number
        name: string
      }
      productId: string
      emphasis?: 'info' | 'accent'
    }>
  }>
}>
